import { Empty, Timeline } from "antd";

const StatusTimeLine = ({ transitions }: any) => {
  const nodeColorMap: any = {
    Active: "#2cc8ba",
    InProgress: "#4fd3e5",
    OnHold: "#fbc11e",
    UnderQC: "#f6a96d",
    Closed: "#74cb80",
    Draft: "#a0aec0",
    Cancelled: "#ff7875",
    default: "#a0aec0",
  };

  // Handle empty transitions
  if (!transitions || transitions.length === 0) {
    return (
      <div
        style={{
          height: 200,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Empty description="No status changes found" />
      </div>
    );
  }

  // Handle single status (no actual transitions, just current state)
  // Check if it's a single item with same from/to or only fromNodeId
  const isSingleStatus =
    transitions.length === 1 &&
    (!transitions[0].toNodeId || transitions[0].fromNodeId === transitions[0].toNodeId);

  if (isSingleStatus) {
    const currentStatus = transitions[0].fromNodeId || transitions[0].toNodeId;
    return (
      <div style={{ padding: "24px 0", display: "flex", justifyContent: "center" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 8,
          }}
        >
          <span style={{ fontSize: 12, color: "#999", marginBottom: 4 }}>Current Status</span>
          <span
            style={{
              padding: "10px 32px",
              borderRadius: 8,
              backgroundColor: nodeColorMap[currentStatus] || nodeColorMap.default,
              color: "#fff",
              fontSize: 15,
              fontWeight: 600,
              textAlign: "center",
              boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
            }}
          >
            {currentStatus}
          </span>
        </div>
      </div>
    );
  }

  const timelineItems = transitions.map((transition: any, index: number) => ({
    color: nodeColorMap[transition.toNodeId] || nodeColorMap.default,
    children: (
      <div style={{ paddingBottom: 20 }}>
        {/* Status change row */}
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 6 }}>
          <span
            style={{
              padding: "6px 20px",
              borderRadius: 6,
              backgroundColor: nodeColorMap[transition.fromNodeId] || nodeColorMap.default,
              color: "#fff",
              fontSize: 13,
              fontWeight: 600,
              minWidth: 90,
              textAlign: "center",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            }}
          >
            {transition.fromNodeId}
          </span>
          <span style={{ color: "#1890ff", fontSize: 18, fontWeight: 500 }}>→</span>
          <span
            style={{
              padding: "6px 20px",
              borderRadius: 6,
              backgroundColor: nodeColorMap[transition.toNodeId] || nodeColorMap.default,
              color: "#fff",
              fontSize: 13,
              fontWeight: 600,
              minWidth: 90,
              textAlign: "center",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            }}
          >
            {transition.toNodeId}
          </span>
        </div>
        {/* Duration and person */}
        <div style={{ fontSize: 12, color: "#666", marginTop: 4 }}>
          <span style={{ marginRight: 12 }}>
            <span style={{ color: "#999" }}>Duration:</span>{" "}
            <span style={{ color: "#333" }}>{transition.duration}</span>
          </span>
          <span>
            <span style={{ color: "#999" }}>By:</span>{" "}
            <span style={{ color: "#333" }}>{transition.person}</span>
          </span>
        </div>
      </div>
    ),
  }));

  return (
    <div style={{ padding: "16px 0" }}>
      <Timeline items={timelineItems} />
    </div>
  );
};

export default StatusTimeLine;
